import * as React from "react"
import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default () => {
  useGSAP(() => {
    gsap.timeline({
      defaults: {
        duration: 0.2,
        ease: 'power1.inOut',
      },
      scrollTrigger: {
        trigger: "#icon-shield",
        start: "top center",
        end: "bottom center",
        markers: false,
        // onEnter, onLeave, onEnterBack, onLeaveBack
        // toggleActions: "play none reset play"
        toggleActions: "play none play reset"
      }
    }).to('.shield-lines', {
        duration: 1,
        strokeDashoffset: 0,
        stagger: 0.2,
      })
    });

 return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 118.69" id="icon-shield" width="100">
      <polyline className="shield-lines" points="68.87 48.57 44.7 72.74 31.13 59.19" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4.46" stroke-dasharray="100" stroke-dashoffset="-100"/>
      <path d="M14.14,28.4v28.26c0,33.4,27.16,44.67,35.86,47.43,8.69-2.76,35.85-14.03,35.85-47.43v-28.26c-15.89-2.08-28.47-7.88-35.85-12.07-7.38,4.19-19.96,9.99-35.86,12.07Z" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4.46"/>
      <path d="M50,116.46s47.76-10.39,47.76-59.78V17.28c-28.17,0-47.76-15.05-47.76-15.05,0,0-19.59,15.05-47.77,15.05v39.4c0,49.39,47.77,59.78,47.77,59.78" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4.46"/>
    </svg>
 );
}